import React from 'react';

import { TableBody } from '@mui/material';

import { IStaffStatistics } from '../../../../types/staff-statistics.type';
import StaffStatisticsItem from '../StaffStatisticsItem';
import StaffStatisticsListGroup from '../StaffStatisticsListGroup';

interface IProps {
  statistics: IStaffStatistics[];
}

const StaffStatisticsListBody = React.memo(({ statistics }: IProps) => {
  const renderStatistics = React.useMemo(() => {
    if (!statistics?.length) {
      return null;
    }

    return statistics.map((item) => (
      <React.Fragment key={`list_${item.groupCode}_${item.productType}`}>
        <StaffStatisticsItem item={item} />
        <StaffStatisticsListGroup item={item} />
      </React.Fragment>
    ));
  }, [statistics]);

  return <TableBody>{renderStatistics}</TableBody>;
});

export default StaffStatisticsListBody;
